import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Bookmark } from "lucide-react";
import { useBookmarkArticle } from "@/hooks/useBookmarkArticle";
import { BlogPost } from "@/hooks/useBlogPosts";
import { cn } from "@/lib/utils";

interface BookmarkButtonProps {
  post: BlogPost;
  variant?: "default" | "ghost" | "outline";
  size?: "default" | "sm" | "lg" | "icon";
  className?: string;
}

export const BookmarkButton = ({ 
  post, 
  variant = "ghost", 
  size = "icon",
  className 
}: BookmarkButtonProps) => {
  const [isBookmarked, setIsBookmarked] = useState(false);
  const { toggleBookmark, checkIfBookmarked, isLoading } = useBookmarkArticle();

  useEffect(() => {
    const checkStatus = async () => {
      const bookmarked = await checkIfBookmarked(post.id);
      setIsBookmarked(bookmarked);
    };
    checkStatus();
  }, [post.id]);

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    const result = await toggleBookmark(post);
    if (result !== null) {
      setIsBookmarked(result);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleClick}
      disabled={isLoading}
      className={cn("transition-colors", className)}
      title={isBookmarked ? "Remove bookmark" : "Bookmark article"}
    >
      <Bookmark 
        className={cn(
          "h-4 w-4",
          isBookmarked && "fill-current text-primary"
        )} 
      />
    </Button>
  );
};
